var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.timer
    ? _c(
        "span",
        {
          attrs: {
            idfosbtimer:
              _vm.timer.idfosbtimer && _vm.timer.idfosbtimer.toString()
          }
        },
        [_vm._v("\n  " + _vm._s(_vm.timerCurrentRealValue) + "\n  ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0078db51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0078db51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/matchTimeDisplay.vue
// module id = null
// module chunks = 